import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-subject-chips',
  templateUrl: './subject-chips.component.html',
  styleUrls: ['./subject-chips.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubjectChipsComponent implements OnChanges {

  @Input() qualified: any[] | null = [];
  @Input() unknown: any[] | null = [];
  @Input() maxVisible = 2;
  @Input() title: string = 'Subjects';
  allSubjects: { label: string; type: string; yearLevel?: string | null; sector?: string | null }[] = [];

  // Handle input changes safely
  ngOnChanges(changes: SimpleChanges): void {
    this.prepareSubjects();
  }

  // Prepare subjects safely (no undefined error)
  prepareSubjects() {
    this.allSubjects = [
      ...(Array.isArray(this.qualified)
      ? this.qualified.map((x: any) => ({
        label: x.subject_name || x,
        type: 'qualified',
        yearLevel: x.yearLevel || null,
        sector: x.sector || null,
        prefNo: x.prefNo || null,
        status: x.status || null,
        subjectCode: x.subjectCode || null,
        subject_name: x.subject_name || null
        }))
      : []),

      ...(Array.isArray(this.unknown)
      ? this.unknown.map((x: any) => ({
        label: typeof x === 'string' ? x : x.subject_name,
        type: 'unknown',
        }))
      : [])
    ];
  }


  get visibleSubjects() {
    return this.allSubjects.slice(0, this.maxVisible);
  }

  get remainingCount() {
    return this.allSubjects.length - this.maxVisible;
  }

  trackByFn(index: number, item: any) {
    return item.label;
  }
}